import api from "./client";

export const DOCUMENTS_QUERY_KEY = "documents";

export type DocumentCategory = "BYLAWS" | "MEETING_MINUTES" | "CONTRACT" | "OTHER";
export type DocumentVisibility = "RESIDENTS" | "ADMINS_ONLY";
export type CommunityDocument = {
  id: string;
  building: string;
  building_name: string;
  title: string;
  description: string;
  category: DocumentCategory;
  visibility: DocumentVisibility;
  original_filename: string;
  content_type: string;
  size_bytes: number;
  uploaded_by_name: string;
  created_at: string;
};

export async function listDocuments(filters: { search: string; category: string; building: string }) {
  return (await api.get<CommunityDocument[]>("/building/documents/", { params: filters })).data;
}

export async function uploadDocument(data: FormData) {
  return (await api.post<CommunityDocument>("/building/documents/", data, { timeout: 120_000 })).data;
}

export async function changeDocumentVisibility(id: string, visibility: DocumentVisibility) {
  return (await api.patch<CommunityDocument>(`/building/documents/${id}/`, { visibility })).data;
}

export async function downloadDocument(document: CommunityDocument) {
  // Fetch with the authenticated client: an ordinary <a> cannot attach JWT.
  const response = await api.get<Blob>(`/building/documents/${document.id}/download/`, { responseType: "blob", timeout: 120_000 });
  const url = URL.createObjectURL(response.data);
  const link = window.document.createElement("a");
  link.href = url;
  link.download = document.original_filename;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
